import { FC, memo } from "react";

const BASE_CLASS =
  "relative px-2 md:px-3 text-[22px] md:text-2xl font-bold text-center md:text-left";

/** Left vertical bar via ::after (md+). Default on; pass false to disable. */
const LEADING_ACCENT_CLASS =
  "after:border-red-200 after:content-[''] md:after:absolute after:top-[50%] after:translate-y-[-50%] after:left-0 after:h-5 after:w-1 after:bg-[#333333] after:rounded-sm";

interface Props {
  title: string;
  className?: string;
  /** Default true (::after bar). Set false for e.g. title beside a back button. */
  leadingAccent?: boolean;
}

const MainTitleBase: FC<Props> = ({
  title,
  className,
  leadingAccent = true,
}) => {
  const classNames = [
    BASE_CLASS,
    leadingAccent ? LEADING_ACCENT_CLASS : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <h1 className={classNames}>{title}</h1>;
};

export const MainTitle = memo(MainTitleBase);
